import { memo } from 'react'

import { PulseScreen } from '@root/features/explore-v2/ui/pulse-screen/pulse-screen'

/**
 * Pulse V2 is a screen of its own, not a page inside the terminal's shell, so
 * this page is only the mounting point. The route is registered outside
 * DesktopLayout for the same reason: none of the old chrome should appear.
 */
export const ExploreV2Page: React.FC = memo(() => <PulseScreen />)
